import {
  auditByConstants,
  auditBy_nameSpace,
} from "../constants/activityLog.constants";
import { activityLogService } from "../services/activityLog.service";

export const getAuditBy = () => {
  return async (dispatch) => {
    dispatch(request());
    try {
      const response = await activityLogService.getAuditBy();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: auditByConstants[`GET_${auditBy_nameSpace}_REQUEST`] };
  }
  function success(response) {
    return {
      type: auditByConstants[`GET_${auditBy_nameSpace}_SUCCESS`],
      response,
    };
  }
  function failure(error) {
    return {
      type: auditByConstants[`GET_${auditBy_nameSpace}_FAILURE`],
      error,
    };
  }
};
